export type ModoTimer = 'regressivo' | 'progressivo';

export const formatarTempo = (segundos: number): string => {
  const total = Math.max(0, Math.floor(segundos));
  const minutos = Math.floor(total / 60);
  const resto = total % 60;

  return `${`${minutos}`.padStart(2, '0')}:${`${resto}`.padStart(2, '0')}`;
};

export const PRESETS = [60, 180, 300, 600, 1200] as const;

export const rotuloPreset = (segundos: number): string =>
  segundos % 60 === 0 ? `${segundos / 60} min` : formatarTempo(segundos);

// setInterval acumula atraso quando a aba fica em segundo plano ou a thread
// engasga; contar pelo relogio faz o timer continuar correto ao voltar.
export const segundosDecorridos = (inicio: number, agora: number): number =>
  Math.max(0, Math.floor((agora - inicio) / 1000));

export const calcularRestante = (alvo: number, decorrido: number): number => Math.max(0, alvo - decorrido);

export const terminou = (modo: ModoTimer, alvo: number, decorrido: number): boolean =>
  modo === 'regressivo' && decorrido >= alvo;
